import { render, staticRenderFns } from "./JobPortalFilters.vue?vue&type=template&id=6a4d5324&scoped=true"
import script from "./JobPortalFilters.vue?vue&type=script&lang=js"
export * from "./JobPortalFilters.vue?vue&type=script&lang=js"
import style0 from "./JobPortalFilters.vue?vue&type=style&index=0&id=6a4d5324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4d5324",
  null
  
)

export default component.exports